import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

export const useAssignSupervisorMentor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      mentorId,
      supervisorId,
    }: {
      mentorId: string;
      supervisorId: string;
    }) =>
      fetchApi({
        url: `v2/mentor/${mentorId}/assign-supervisor`,
        method: "POST",
        data: {
          supervisorId,
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["supervisorMentors", variables.supervisorId],
      });
      queryClient.invalidateQueries({
        queryKey: ["userSupervisorAndChannel", variables.mentorId],
      });
      queryClient.invalidateQueries({
        queryKey: ["userLeadMentors", variables.mentorId],
      });
    },
  });
};
